import { showAgreementPopup, showPrivacyAgreementPopup } from '@/core/presenter/controller/PopupController';
import { ModalId } from '@/core/presenter/viewModel/viewTypes';
import { useStores } from '@/stores';
import { useState, useCallback, useEffect } from 'react';

export default function useJoinGuideView(onClick: () => void) {
  const { userStore } = useStores();
  const [checkboxStates, setCheckboxStates] = useState({
    allAgree: false,
    terms1: false,
    terms2: false,
  });
  const isRequiredTermsChecked = checkboxStates.terms1 && checkboxStates.terms2;

  useEffect(() => {
    userStore.setPassword('');
  }, [checkboxStates, userStore]);

  // 전체 동의 체크박스 핸들러
  const onChangeAllAgree = () => {
    const newValue = !checkboxStates.allAgree;
    setCheckboxStates({
      allAgree: newValue,
      terms1: newValue,
      terms2: newValue,
    });
  };

  /**
   * 개별 체크박스 핸들러
   * @param name
   */
  const onChangeSingleCheck = (name: keyof typeof checkboxStates) => {
    const newStates = {
      ...checkboxStates,
      [name]: !checkboxStates[name],
    };

    // 모든 항수 항목이 체크되었는지 확인
    const allChecked = Object.entries(newStates)
      .filter(([key]) => key !== 'allAgree')
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .every(([_, value]) => value);

    setCheckboxStates({
      ...newStates,
      allAgree: allChecked,
    });
  };

  /**
   * 체크박스 클릭 핸들러
   * @param e
   */
  const onClickCheckBox = useCallback((e: React.MouseEvent<HTMLElement>) => {
    const target = e.currentTarget;
    const modalId = target.getAttribute('data-modal');

    if (modalId === ModalId.TERMS_1) showAgreementPopup();
    if (modalId === ModalId.TERMS_2) showPrivacyAgreementPopup();
  }, []);

  /**
   * 다음 버튼 클릭 핸들러
   */
  const onClickNextBtn = useCallback(() => {
    // 필수 약관 동의 확인
    if (isRequiredTermsChecked) onClick();
  }, [isRequiredTermsChecked, onClick]);

  return {
    checkboxStates,
    isRequiredTermsChecked,
    onChangeAllAgree,
    onChangeSingleCheck,
    onClickCheckBox,
    onClickNextBtn,
  };
}
